import { SharedReportParams } from './useSharedReportsQuery';

export const sharedReportKeys = {
  shared_reprots: (params: SharedReportParams) =>
    ['SHARED_REPROTS', params] as const,
};
